import React, { useRef, useState } from "react";
import { useSnackbar } from "notistack";
import {
  Avatar,
  Box,
  Divider,
  Stack,
  IconButton,
  MenuItem,
  Typography,
  Select,
  Popover
} from '@mui/material';
import useAuth from "../../contextapi/hooks/useAuth";
import Img from "../../assets/img/avatar.png";
import { alpha } from '@mui/material/styles';

const Account = () => {
  const {
    user,
    logoutUser,
  } = useAuth();
  const userApp = user;
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const spanRef = React.useRef();

  const handleOpen = () => {
    setAnchorEl(spanRef.current);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null)

  };

  const handleLogout = async () => {
    try {
      handleClose();
      await logoutUser(userApp.dt11);
    } catch (err) {
     
    }
  };

  React.useEffect(() => {

  }, []);



  return (
    <>
      <IconButton
        ref={spanRef}
        onClick={handleOpen}

        sx={{
          p: 0,
          ...(isOpen && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={user.userPictureUrl != "" ? user.userPictureUrl: Img} alt="photoURL" />
      </IconButton>


      <Popover
        open={Boolean(isOpen)}
        anchorEl={anchorEl}
        onClose={handleClose}
        disableRestoreFocus
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        {/* <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.completeNames}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.email}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.rolName}
          </Typography>
          
        </Box> */}

        <Divider sx={{ borderStyle: 'dashed' }} />



        <MenuItem disableRipple onClick={handleLogout}>Cerrar sesión</MenuItem>
      </Popover>
    </>
  );
};

export default Account;
